import http from '@/services/http'
import { delayed } from '@/utils'
import _ from 'lodash'

const FIELDS = ['id', 'name', 'logo_url', 'is_public']

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    organization: { features: [] },
    features: [],
    original: {},
    saveInProgress: false,
    fetched: false,
  },
  mutations: {
    CLEAR(state) {
      FIELDS.forEach((f) => {
        state.organization[f] = null
        state.original[f] = null
      })
    },
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    SET_ORGANIZATION_DATA(state, organization) {
      state.organization = organization
      state.original = _.cloneDeep(organization)
      state.fetched = true
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },

    START_SAVE(state) {
      state.saveInProgress = true
    },
    STOP_SAVE(state) {
      state.saveInProgress = false
    },

    UPDATE_NAME(state, { name }) {
      state.organization.name = name
    },
    UPDATE_LOGO_URL(state, { logo_url: logoUrl }) {
      state.organization.logo_url = logoUrl
    },
    UPDATE_IS_PUBLIC(state, { is_public: isPublic }) {
      state.organization.is_public = isPublic
    },
    UPDATE_HAS_DEMO_MODE_ENABLED(state, { hasDemoModeEnabled }) {
      state.organization.has_demo_mode_enabled = hasDemoModeEnabled
    },
    UPDATE_HAS_DEMO_MODE_ENABLED_REPORTS(state, { hasDemoModeEnabledReports }) {
      state.organization.has_demo_mode_enabled_reports =
        hasDemoModeEnabledReports
    },
    UPDATE_TYPE(state, { type }) {
      state.organization.type = type
    },

    enableFeature(state, { feature }) {
      state.organization.features = state.organization.features.concat([
        feature,
      ])
    },
    disableFeature(state, { feature }) {
      state.organization.features = state.organization.features.filter(
        (f) => f !== feature,
      )
    },
  },
  getters: {
    isFeatureEnabled: (state) => (feature) =>
      state.organization.features.includes(feature),
  },
  actions: {
    async fetch({ commit }, { id }) {
      commit('START_FETCH')
      const request = http.getAuthed(`/organizations/${id}`)

      try {
        const response = await delayed(request, 0)
        commit('SET_ORGANIZATION_DATA', response.data)
        return response.data
      } finally {
        commit('STOP_FETCH')
      }
    },
    async save(
      { commit, state },
      {
        name,
        logo_url,
        is_public,
        has_demo_mode_enabled,
        has_demo_mode_enabled_reports,
        type,
      },
    ) {
      commit('START_SAVE')
      const data = {
        name,
        logo_url,
        is_public,
        has_demo_mode_enabled,
        has_demo_mode_enabled_reports,
        type,
      }
      await http.postAuthed(
        `/organizations/${state.organization.id}/update`,
        data,
      )
      commit('STOP_SAVE')
    },

    async enableFeature({ state, commit }, { feature }) {
      commit('enableFeature', { feature })
      await http.postAuthed(
        `/organizations/${state.organization.id}/enable-feature`,
        { feature },
      )
    },
    async disableFeature({ state, commit }, { feature }) {
      commit('disableFeature', { feature })
      await http.postAuthed(
        `/organizations/${state.organization.id}/disable-feature`,
        { feature },
      )
    },
  },
}
